var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/search-icon-asset.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n\n<svg class=\"c-site-search__img\" aria-labelledby=\"search-title\" viewBox=\"0 0 22.865 22.865\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"search-title\">";
output += runtime.suppressValue((lineno = 4, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_search"])), env.opts.autoescape);
output += "</title>\n\n    <ellipse transform=\"rotate(-45 8.897 8.889)\" cx=\"8.897\" cy=\"8.889\" rx=\"8.111\" ry=\"8.111\"></ellipse>\n    <path d=\"M14.632 14.624l7.457 7.457\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/search-icon-asset.j2"] , dependencies)